import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands } from '../../../core/services/command/command.service';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { ComposeAtomicTaskDialogComponent } from "src/app/shared-module/components/compose-atomic-task-dialog/compose-atomic-task-dialog.component";

@Injectable({
    providedIn: 'root'
  })
export class ComposeAtomicTaskCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService,
        private router: Router
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      this.dialogRef = this.dialogService.open(ComposeAtomicTaskDialogComponent, {
        width: "500px",
        header: commandTemplate?.settings?.label,
        data: {
          commandTemplate: commandTemplate,
        }
      });
      this.dialogRef.onClose.subscribe((result) => {
        // result is true or false, indiciating if it should refetch
        console.log('result', result);
        if(result){
          commandInput.addParameter("taskIds", result.taskIds);
          commandService.sendCommand(commandInput, () => {
            // Navigate to tasks list if current URL shows a specific task
            // A composit task may be created after the compose, and that is not
            // the task, that we showed, so we navigate back to the tasks list
            // As long as we do not have the side panel overview implemented everywhere
            // we must filter the cases manually
            const currentUrl = this.router.url;
            const taskDetailPattern1 = /\/tasks\?type=task&show=[a-f0-9-]+/;
            const taskDetailPattern2 = /\/tasks\/task\/[a-f0-9-]+/;
            
            if (taskDetailPattern1.test(currentUrl) || taskDetailPattern2.test(currentUrl)) {
              this.router.navigate(['/tasks']);
            }
            
            completionCallback();
          })
        }
      });

    
  }
  
}